import request from '@/services/utils/request'

// 账号密码登录 ✅
export function login(phone: string, pwd: string) {
    const data = { phone, pwd }
    return request({
        url: '/member/auth/pwdLogin',
        headers: {
            isToken: false
        },
        method: 'POST',
        data: data
    })
}

// 微信手机号授权登录 ✅
export function wechatLogin(data: { code: string; appid: string }) {
    return request({
        url: '/user/app/auth/wechat-login',
        headers: {
            isToken: false
        },
        method: 'POST',
        data: { code: data.code, appId: data.appid }
    })
}

// 手机号+验证码登录 ❌ 没有做
export function smsLogin(data: { mobile: string; code: string }) {
    return request({
        url: '/user/app/auth/sms-login',
        headers: {
            isToken: false
        },
        method: 'POST',
        data: data
    })
}

// 退出登录 ✅
export function logout() {
    return request({
        url: '/user/app/auth/logout',
        method: 'POST'
    })
}

// 新-获取用户信息 ✅
export function getUserInfo() {
    return request({
        url: '/user/app/user/profile',
        method: 'GET'
    })
}

// 发送验证码
export function sendSmsCode(data: { mobile: string; scene: 1 | 2 }) {
    //  scene 场景:1-登录 2-注册
    return request({
        url: '/user/app/auth/send-sms-code',
        method: 'POST',
        data: data
    })
}

// 重置密码
export function resetPassword(data: { mobile: string; code: string; newPassword: string }) {
    return request({
        url: '/user/app/auth/reset-password',
        method: 'POST',
        data: data
    })
}

// 更新密码
export function updatePassword(data: { oldPassword: string; newPassword: string }) {
    return request({
        url: '/user/app/user/update-password',
        method: 'PUT',
        data: data
    })
}

// 更新用户信息
export function updateUserInfo(data: { nickname: string; mobile: string; email: string; sex: 0 | 1 | 2; avatar: string }) {
    return request({
        url: '/user/app/user/update-profile',
        method: 'PUT',
        data: data
    })
}

// 获取用户权限信息 ❌ 此项目不用
export function getInfo() {
    return request({
        url: '/system/auth/get-permission-info',
        method: 'GET',
        params: { platform: 'h5' }
    })
}

export function quickLogin(data: { code: string; appid: string }) {
    return request({
        url: '/user/app/auth/quick-login',
        headers: {
            isToken: false
        },
        method: 'POST',
        data: { code: data.code, appId: data.appid }
    })
}
